export default {
  potential: {
    banner: 'Pseudopotential',
    title: 'Introduction to Pseudopotential',
    titleP1:`
    Currently, we provide two types of pseudopotentials: norm-conserving pseudopotentials and
    ultrasoft pseudopotentials. These pseudopotentials are in the UPF2.0 format of
    `,
    titleP1_2: '. The pseudopotential library files we provide are compiled from other open source libraries.',
    titleP2: 'For norm-conserving pseudopotentials, we provide three types:',
    titleP2_2: 'and',
    titleP2_4: '. Both SG15 and PD03 pseudopotentials are generated using',
    titleP2_5: `
     (Optimized Norm-Conservinng Vanderbilt PSeudopotential). SG15 and PD03 are recently developed
     norm-conserving pseudopotentials, which are more accurate than the old pseudopotentials.
     However, since some pseudopotentials contain semicores, a larger cutoff is required to ensure convergence.
     This also slows down the calculation speed and increases memory requirements.
     FHI is "softer" than the above two pseudopotentials, but the accuracy is relatively lower.
    `,
    titleP3: 'For ultrasoft pseudopotentials, we also provide two types: USPP-SOFT and',
    titleP3_2: `
     . GBRV pseudopotential also has a larger cutoff energy due to semicores,
     but the calculation is more accurate; while the cutoff energy of USPP-SOFT is smaller and the accuracy is slightly lower.
    `,
    titleP4: 'For a comparison of the performances of the above pseudopotentials, please refer to this paper: ',
    titleP5: `
    In addition, we also provide a set of SOC pseudopotentials for nonlinear calculations
    and a set of H fractional pseudopotentials for H passivation calculations.
    `,
    titleP6: `
    PWmat versions after 20221123 support Gaussian basis groups.
    We provide the BASIS and pseudopotentials required for Gaussian basis groups,
    GTH_BASIS_SETS , GTH_POTENTIALS , BASIS_MOLOPT . In addition, users can also obtain them from
    `,
    titleP6_2: 'website.',
    part2: 'Download Link',
    part3: 'Instructions',
    part3P1: 'For ultrasoft pseudopotentials, it is required that ECUT2L=4*ECUT2.',
    part3P2: `
    For most calculations, setting ECUT2 = 2*ECUT is sufficient. If higher calculation accuracy is required,
    ECUT2 = 4*ECUT can be set. For lanthanide elements, it is recommended to set Ecut equal to 90~120Ryd and Ecut2 = 4*Ecut.
    `,
    part3p3: `
    For atomic relaxation, if you find that the relaxation force no longer decreases, you can also set ECUT2=4*ECUT.
    For better relaxation effect (of course, it takes up more computing resources), you can set ECUT2=4*ECUT, ECUT2L=4*ECUT2.
    `,
    part3P4: 'To take into account the EGG_HEAD correction before the relaxation calculation, you can also set ECUT2=4*ECUT, ECUT2L=ECUT2.',
    part3P5: `
    For lattice relaxation, in order to obtain a more reasonable lattice,
    a larger cutoff energy is required. Generally, 10~20Ry larger than the default ECUT is sufficient.
    `,
    part3P6: `
    For other types of calculations, such as molecular dynamics calculations and energy band calculations,
    you can appropriately adjust the settings of ECUT, ECUT2,
    and ECUT2L (reduce the ECUT value, and reduce the multiple relationship of ECUT, ECUT2, and ECUT2L).
    `,
    part3P7: `
    For the hydrogen pseudopotential, the method to distinguish different hydrogens is mainly to modify the relative
    atomic number in atom.config. Whether it is a normal hydrogen pseudopotential or a hydrogen pseudopotential,
    their atomic number is generally 1. PWmat mainly matches different pseudopotentials and atoms by atomic number.
    Therefore, in order to distinguish between normal hydrogen pseudopotential and hydrogen pseudopotential,
    the atomic number of hydrogen needs to be set in the atom.config file according to the following rules:
    `,
    part3P8: `
    109 --- H_0.25.SG15.PBE.UPF means that 109 in atom.config will correspond to the pseudopotential
    of H_0.25. In the unzipped H.zip folder there is a README.TXT file for reference and an example folder for testing.
    `,
  }
}